<modal-dialog [title]="'Error'" [cancelText]="'Cerrar'">
    <p>{{message}}</p>
</modal-dialog>